import React, { ReactNode, FunctionComponent, isValidElement } from 'react';

type CtaBoxMediaProps = {
    children: ReactNode;
    qaRole?: string;
};

const CtaBoxMedia: FunctionComponent<CtaBoxMediaProps> = ({ children, qaRole }) => {
    // todo: check the children validation
    if (!isValidElement(children)) {
        return null;
    }

    return (
        <div className="cta-box__media" data-qa-role={qaRole || 'cta-box-media'}>
            {children}
        </div>
    );
};

export default CtaBoxMedia;
